import React from 'react';

import Office365AltLogo from 'Shared/components/Logos/Office365AltLogo';
import './Office365Button.scss';

type Props = {
  openNewTab: boolean;
  openWithZoomSDK?: boolean;
  className: string;
  office365SignUpUrl: string;
  children: React.ReactNode;
};

function Office365Button({ openNewTab, openWithZoomSDK, className, office365SignUpUrl, children }: Props) {
  const handleButtonClick = event => {
    if (openNewTab) {
      event.preventDefault();
      window.open(office365SignUpUrl);
    }

    if (openWithZoomSDK) {
      event.preventDefault();
      (window as any).zoomSdk.openUrl({ url: `${window.location.origin}/${office365SignUpUrl}` });
    }
  };

  return (
    <a
      className={`office-365-button btn d-flex p-0 align-items-center w-100 ${className}`}
      href={office365SignUpUrl}
      onClick={handleButtonClick}
    >
      <div className="office-365-button-logo-container">
        <Office365AltLogo width="30" height="30" />
      </div>
      <div className="px-1 text-left w-100">{children}</div>
    </a>
  );
}

export default Office365Button;
